import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "count"]

  connect() {
    this.updateCount()
  }

  updateCount() {
    if (!this.hasTextareaTarget || !this.hasCountTarget) return

    const lines = this.parsePrompts()
    this.countTarget.textContent = `${lines.length} prompt${lines.length === 1 ? "" : "s"}`
  }

  parsePrompts() {
    const text = this.hasTextareaTarget ? this.textareaTarget.value : ""
    return text.split("\n").map(l => l.trim()).filter(l => l.length > 0)
  }
}
